export default __webpack_public_path__ + "static/media/envelope.91edc490.svg";